/*
    创建者：shuxiaokai
    创建时间：2019-11-18 16:32
    模块名称：xxxx
    备注：xxxx
*/
<template>
    <div class="ml-5 mt-5 d-flex">
        <br>
        <!-- flex相关 -->
        <div class="w-100px h-100px border-teal rotate-50">rotate</div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    created() {

    },
    methods: {

    }
};
</script>



<style lang="scss">

</style>
